export function isFlatRentQuery(queryString: string) {
  const parsedQuery = new URLSearchParams(queryString);

  return (
    parsedQuery.get('deal_type') === 'rent' &&
    parsedQuery.get('offer_type') === 'flat' &&
    parsedQuery.get('type') === '4'
  );
}
